import React from "react";
import { motion } from "framer-motion";
import StatusPill from "./StatusPill";

const toneFor = (level) =>
  level === "High" ? "critical" : level === "Medium" ? "warning" : level === "Low" ? "success" : "info";

export default function RiskSummary({ items = [] }) {
  return (
    <div className="card-eco p-6" data-testid="risk-summary-widget">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">
            Risk Summary
          </div>
          <div className="mt-1 font-display text-lg text-slate-100">
            Multi-dimensional risk posture
          </div>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3">
        {items.map((r, i) => (
          <motion.div
            key={r.name}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * i }}
            className="rounded-xl border border-white/5 bg-white/[0.02] p-4"
            data-testid={`risk-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400">
              {r.name.replace(" Risk", "")}
            </div>
            <div className="mt-2 flex items-baseline justify-between gap-2">
              <span className="font-mono text-2xl font-light text-white">{r.value}</span>
              <StatusPill tone={toneFor(r.level)} dot={false}>{r.level}</StatusPill>
            </div>
            <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/[0.04]">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${r.value}%` }}
                transition={{ duration: 1, delay: 0.1 + 0.05 * i }}
                className="h-full rounded-full"
                style={{ background: r.color }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
